<template>
  <div id="cul_reports_gen">
    <div id="SelectionArea">
      <h2 style="padding-left: 10px; padding-top: 20px;">Select Report</h2>
      <v-layout row style="padding: 10px;">
        <v-radio-group v-model="reportType" row style="margin: 0px; padding-left: 10px;">
          <v-spacer />
          <v-radio label="Active Records" value="active"></v-radio>
          <v-radio label="All Records" value="historical"></v-radio>
        </v-radio-group>
      </v-layout>
      <div>
        <v-container style="padding: 10px; margin: 3px" grid-list-md>
          <v-layout row wrap>
            <v-flex xs12 md4>
              <v-select
                label="Report Category"
                :items="types"
                item-text="type"
                item-value="report"
                v-model="selType"
                @input="typeChanged"
              ></v-select>
            </v-flex>
            <v-flex v-for="sel in selectors" :key="sel.id">
              <v-select
                :label="sel.label"
                :items="sel.items"
                @input="choice => updateChoice(sel, choice)"
              ></v-select>
            </v-flex>
            <v-flex xs12 md4>
              <VueCtkDateTimePicker
                v-if="pickDay"
                label="Select Date Range"
                v-model="dateRange"
                output-format="ll"
                format="YYYY-MM-DD"
                :range="true"
                :dark="dark"
              ></VueCtkDateTimePicker>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <v-btn
        v-if="showGenerate"
        class="ma-2"
        :loading="loading"
        :disabled="loading"
        color="green"
        @click="getReport"
      >Generate Report</v-btn>
      <v-btn
        v-if="showPrint"
        class="ma-2"
        :loading="loading"
        :disabled="loading"
        color="red"
        @click="print"
      >Print Report</v-btn>
    </div>
    <div id="ReportArea" v-html="DataSet"></div>
  </div>
</template>

<script>
import axiosInstances from '@/../../coreui/server/axiosInstances'
import { sync } from "vuex-pathify";
import helper from "./helper";
export default {
  components: {},
  data: () => ({
    loader: null,
    loading: false,
    pickDay: false,
    DataSet: null,
    reportToGet: null,
    reportType: "active",
    reportParams: null,
    selType: null,
    selectors: [],
    showGenerate: false,
    showPrint: false,
    types: [],
  }),
  computed: {
    dark: sync("dark"),
    translator: sync("translator"),
  },
  methods: {
    print() {
      const element = window.document.getElementById("ReportArea");

      const win = window.open("", "_blank");

      win.document.write(`${element.innerHTML}`);

      setTimeout(() => {
        win.document.close();
        win.focus();
        win.print();
        win.close();
        cb();
      }, 1000);
    },
    async getReport() {
      this.loading = true;
      let res = await helper.getReport(this.reportToGet, this.reportParams);
      this.DataSet = res.data;
      this.loading = false;
      this.showGenerate = false;
      this.showPrint = true;
    },
    async typeChanged(val) {
      let self = this;
      console.log(`report type changed ${val}`);
      let def = self.types.find((x) => x.report === val);
      console.table(`types array = ${self.types}`);
      console.table(`def = ${def}`);
      self.reportToGet = def.report;
      console.log(`report to get = ${self.reportToGet}`);
      console.log(`Getting the first selection`);
      self.selectors = [];
      self.showGenerate = false;
      self.showPrint = false;
      self.DataSet = null;
      let firstSel = def.selectors.find((x) => x.id === 1);
      if (firstSel !== undefined) {
        let selection = await helper.getSelection(
          firstSel,
          self.reportType,null
        );
        self.selectors.push(selection);
      }
    },
    async updateChoice(selection, choice) {
      console.log(`Choice ID = ${selection.id}`);
      console.log(`Choice = ${choice}`);
      let paramOBJ = {};
      paramOBJ["value"] = choice;
      paramOBJ["src"] = selection.src;
      paramOBJ["name"] = selection.name;
      paramOBJ["field"] = selection.field;
      paramOBJ["id"] = selection.id;
      if (this.reportParams === null) this.reportParams = [];
      if (this.reportParams.length === 0) this.reportParams.push(paramOBJ);
      else {
        let index = this.reportParams.findIndex((x) => x.id === selection.id);
        if (index === -1) this.reportParams.push(paramOBJ); 
        else {
          this.reportParams[index] = paramOBJ
        }
      }
      let next = selection.next;
      this.showPrint = false;
      this.DataSet = "";
      if (parseInt(next) === -1) {
        console.log("Ready to generate");
        this.showGenerate = true;
      } else {
        this.showGenerate = false;
        this.selectors.length = selection.id;
        this.reportParams.length = selection.id;
        console.log(`selection id = ${selection.id}`);
        let selectorGroup = this.types.find(
          (x) => x.report === this.reportToGet
        );
        let nextSelection = selectorGroup.selectors.find((x) => x.id === next);
        let updateSelection = await helper.getSelection(
          nextSelection,
          this.reportType,
          this.reportParams
        );
        this.selectors.push(updateSelection);
      }
    },
  },
  async beforeMount() {
    console.log("In the before mount function");
    let reportChoices = await helper.getReportList("rpt_cultivation");
    console.table(reportChoices);
    this.types = reportChoices;
  },
  beforeDestroy() {},
};
</script>